<!--
/*******************************************************************************
*@ 컴포넌트명   : PrintArea.vue
*@ 컴포넌트설명 : 영역 캡처 및 공유하기 공통컴포넌트 - 영역설정
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자 : 함성호  변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div>
    <div id="printArea"><h2>TEST</h2></div>
  </div>
</template>
<script>
import html2canvas from "@/assets/js/html2canvas.js"; // html -> image
// import QRCodeStyling from "@/assets/js/qr-code-styling.min.js"; // qr styling
export default {
    name: "PrintArea",
    components: {},
    mounted(){
        // try{
        //     const shareArea = document.getElementById("printArea");
        //     var promise = new Promise((resolve, reject) => {
        //         resolve(
        //             html2canvas(shareArea).then(function(canvas) {
        //                 var image = canvas.toDataURL("image/jpeg", 1.0);
        //                 return image;
        //             })
        //         ),
        //         reject (
        //             "html2Canvas Failed"
        //         );
        //     });
                    
        //     // result = imagePath (image)
        //     promise.then(result => {
        //         console.log(result);
        //         return result;
        //     }).catch(error => {
        //         return error;
        //     })
        // } catch (error){
        //     console.log(error);
        // }
        
        try{
            // 캡처 또는 공유하는 영역은 동일하기 때문에 printArea로 통일
            const printArea = document.getElementsByName("PRINT_AREA");
            console.log("length23 : " + printArea.length);
            for(let i = 0; i < printArea.length; i++){
         
                let area = printArea[i].cloneNode(true);
                let removeArea = area.querySelectorAll(".REMOVE_AREA");

                if(removeArea.length > 0){
                    for(let j = 0; j < removeArea.length; j++){
                        removeArea[j].parentNode.removeChild(removeArea[j]);
                    }
                }

                document.getElementById("printArea").innerHTML += area.innerHTML;
            }
            this.$i18n.locale = this.lang;

            let area = window.document.getElementById("printArea");
            console.log("area : " + JSON.stringify(area));
            var promise = new Promise((resolve, reject) => {
                resolve(
                    html2canvas(area).then(function(canvas) {
                        var image = canvas.toDataURL("image/jpeg", 1.0);
                        return image;
                    })
                ),
                reject (
                    "html2Canvas Failed"
                );
            });
                    
            // result = imagePath (image)
            promise.then(result => {
                // console.log(result);
                return result;
            }).catch(error => {
                return error;
            })
        } catch (err) {
            return err;
        }
        
    },
    data() {
        return {};
    }
};
</script>
